<template>
    <div class="timetable-list" v-bind:class="{
        'is-loading': isLoading,
        'show-menu': showMenu,
    }">
        <div v-show="showTimetableView" class="flex">
            <!-- <div class="how-to-schedule" v-if="showHowToRegister">
                <i class="icon-question"></i>
                <ul>
                    <li>{{texts.free_lessons_description}} <span class="bg-lesson-free"></span></li>
                    <li>{{texts.scheduled_lessons_description}} <span class="bg-lesson-scheuled"></span></li>
                </ul>
            </div> -->

            <div class="col-left-side" @click.stop v-bind:class="{
                'mr-4': showMenu,
            }">
                <v-date-picker ref="datepicker" mode="date" @dayclick="dayClicked" v-model="date" is-required
                    :locale="locale">
                </v-date-picker>

                <div v-if="freeEventsUrl" class="my-[20px]">
                    <button class="btn btn-primary btn-block" @click="toggleFreePlacesView()">
                        {{ texts.open }}
                        {{ view !== 'free_places' ? texts.views['free_places'] : texts.views[oldView] }}
                    </button>
                </div>

                <div v-if="typeof calendarListUrls == 'object'">
                    <select v-model="calendarListUrl" class="mt-2 form-control">
                        <option v-for="_calendarList in calendarListUrls" v-bind:value="_calendarList.url">
                            {{ _calendarList.name }}
                        </option>
                    </select>
                </div>

                <div v-for="filter in filters" :key="'filter-key-' + filter.key">
                    <h3 class="text-xl mt-[18px] mb-[10px]">{{ filter.title }}</h3>
                    <div class="mb-[10px]">
                        <div class="mb-[10px]">
                            <button class="btn btn-sm border rounded-md mb-[5px] mr-[4px]"
                                v-for="option in filter.options" :key="'step-1-btn-' + option.title" :class="{
                                    'btn-primary': selectedGearboxType == option,
                                    'tt-btn-outline': selectedGearboxType !== option,
                                }" @click="setGearboxType(option)">
                                {{ option.title }}
                            </button>
                        </div>
                        <div v-if="selectedGearboxType">
                            <div v-for="subFilter in selectedGearboxType.sub_filters"
                                :key="'step-1-filter-' + subFilter.key">
                                <h3 class="text-xl mt-[18px] mb-[10px]">
                                    {{ subFilter.title }}
                                </h3>
                                <div class="mb-[10px]">
                                    <button class="btn btn-sm border rounded-md mb-[5px] mr-[4px]"
                                        v-for="option in subFilter.options" :key="'step-1-filter-opt-' + option.title"
                                        :class="{
                                            'btn-primary': selectedCarModel == option,
                                            'tt-btn-outline': selectedCarModel !== option,
                                        }" @click="setCarModel(option)">
                                        {{ option.title }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="px-[2px] mb-[10px] mt-[20px]">
                            <input type="text" id="calendar_search" class="
                                tt-input
                                form-control
                                border
                                !rounded
                                w-full
                            " v-bind:placeholder="texts.search_instructor" v-model="calendarSearch" />
                        </div>
                        <div v-if="filteredCalendars.length == 0 && filteredHighlightedCalendars.length == 0">
                            {{ texts.not_found_instructors }}
                        </div>

                        <h3 class="text-xl mt-[18px] mb-[10px]" v-if="filteredHighlightedCalendars.length">
                            {{ userIsScheduling ? texts.your_instructors : texts.student_instructors }}
                        </h3>
                        <div class="mb-1 calendar-item group" v-for="calendar in filteredHighlightedCalendars"
                            @click="selectCalendar(calendar)" v-if="calendar.isHighlighted" v-bind:class="{
                                active: calendar.id === selectedCalendar?.id,
                                highlighted: calendar.isHighlighted
                            }" :key="calendar.id">
                            <div
                                class="box-border border rounded-lg cursor-pointer tt-card p-[12px] group-[.active]:border-primary group-[.active]:border-2">
                                <div class="text-lg group-[.active]:mb-[8px]">
                                    <i class="mr-1" v-bind:class="calendar.icon || 'icon-user'"></i>
                                    {{ calendar.title }}
                                </div>

                                <div class="hidden group-[.active]:block space-y-[8px]">
                                    <div class="flex justify-center">
                                        <img v-bind:src="calendar.picture" alt="" v-img-zoom
                                            class="w-[120px] max-w-full" />
                                    </div>
                                    <p class="text-lg" v-if="calendar.info" v-for="info in calendar.info"
                                        :key="calendar.id + '-info-' + info.key">
                                        <small>{{ info.key }}</small>
                                        <b v-html="info.value"></b>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <h3 class="text-xl mt-[18px] mb-[10px]" v-if="filteredCalendars.length">
                            {{ filteredHighlightedCalendars.length ? texts.other_instructors : texts.select_instructor }}
                        </h3>
                        <div class="mb-1 calendar-item group" v-for="calendar in filteredCalendars"
                            @click="selectCalendar(calendar)" v-if="!calendar.isHighlighted" v-bind:class="{
                                active: calendar.id === selectedCalendar?.id,
                                highlighted: calendar.isHighlighted
                            }" :key="calendar.id">
                            <div
                                class="box-border border rounded-lg cursor-pointer tt-card p-[12px] group-[.active]:border-primary group-[.active]:border-2">
                                <div class="text-lg group-[.active]:mb-[8px]">
                                    <i class="mr-1" v-bind:class="calendar.icon || 'icon-user'"></i>
                                    {{ calendar.title }}
                                </div>

                                <div class="hidden group-[.active]:block space-y-[8px]">
                                    <div class="flex justify-center">
                                        <img v-bind:src="calendar.picture" alt="" v-img-zoom
                                            class="w-[120px] max-w-full" />
                                    </div>
                                    <p class="text-lg" v-if="calendar.info" v-for="info in calendar.info"
                                        :key="calendar.id + '-info-' + info.key">
                                        <small>{{ info.key }}</small>
                                        <b v-html="info.value"></b>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <timetable-list-filter
          v-for="filter in filters"
          :key="filter.key"
          :filter="filter"
          :calendars="calendars"
          :selected-calendar="selectedCalendar"
          @select-calendar="selectCalendar"
        ></timetable-list-filter> -->
            </div>
            <div class="col-right-side">
                <timetable :action="innerAction" ref="timetable" :local-event-bus="eventBus" :show-date="date"
                    :hide-past-events="hidePastEvents" :hide-vacation-events="hideVacationEvents"
                    :events-url="innerEventsUrl"
                    :store-events-url="innerStoreUrl"
                    :update-events-url="innerUpdateUrl"
                    :delete-events-url="innerDeleteUrl" :block-scheduling-after-hour="selectedCalendar && selectedCalendar.block_scheduling_after_hour
                                " :schedule-event-params="scheduleEventParams" :can-schedule-recurring-events="isWorkSchedule"
                    :prevent-overlap="isWorkSchedule"
                    :show-first-event="false" :show-schedule-view="showScheduleView" :free-events-url="innerFreeEventsUrl"
                    :events-info-url="innerEventsInfoUrl" :show-month-view="showMonthView" :show-trash-view="showTrashView"
                    :event-extra-fields="innerEventExtraFields" :translations="translations" :highlighted="highlighted"
                    :selected-car-model="selectedCarModel" :selected-gearbox-type="selectedGearboxType"
                    :reschedule-events-url="rescheduleEventsUrl" :drag-mode="dragMode"
                    :slot-snap-minutes="slotSnapMinutes"
                    :restrict-practice-to-free-slots="restrictPracticeToFreeSlots"
                    :menu-open="showMenu" :has-menu="true"
                    :default-duration-in-minutes="defaultDurationInMinutes"
                    :vacation-store-url="innerVacationStoreUrl" :vacation-delete-url="innerVacationDeleteUrl">
                    <!-- Below the navigation, and always rendered. It used to sit above
                         and only exist once an instructor was picked, so choosing one
                         shoved the whole navigation down. The empty state holds the same
                         space and says what to do. -->
                    <template #context="ctx">
                        <div class="tt-instructor-bar" v-bind:class="{ 'is-empty': !hasSelectedCalendar }">
                            <template v-if="hasSelectedCalendar">
                                <img v-bind:src="selectedCalendar.picture" alt="" v-img-zoom
                                    class="tt-instructor-bar__avatar" />
                                <span class="tt-instructor-bar__name">{{ selectedCalendar.title }}</span>
                                <div class="tt-instructor-bar__info"
                                    v-if="selectedCalendar.info && selectedCalendar.info[0]"
                                    v-html="selectedCalendar.info[0].value"></div>
                                <button class="tt-icon-btn tt-icon-btn--round"
                                    v-bind:title="texts.clear_instructor"
                                    v-bind:aria-label="texts.clear_instructor"
                                    @click="selectCalendar(null, true)">
                                    <i class="text-lg icon-close" aria-hidden="true"></i>
                                </button>

                                <!-- Holidays belong to the instructor, so they sit with the
                                     instructor rather than in the calendar's navigation --
                                     where they also pushed that row onto two lines. -->
                                <div class="tt-instructor-bar__actions" v-if="ctx.showVacationAction">
                                    <reserve-menu
                                        :select-mode="ctx.vacationSelectMode"
                                        :selected-count="ctx.vacationSelectedCount"
                                        :texts="texts"
                                        @reserve="addVacation"
                                        @select-days="startVacationSelect()"
                                        @confirm="confirmVacationSelect()"
                                        @cancel="cancelVacationSelect()"
                                    ></reserve-menu>
                                </div>
                            </template>

                            <!-- With the rail hidden the list is out of reach, so the hint
                                 doubles as the way back to it. With the rail open the list
                                 is already there and a button would just close it. -->
                            <button v-else-if="!showMenu" type="button"
                                class="tt-instructor-bar__hint tt-instructor-bar__hint--action"
                                @click.stop.prevent="toggleMenu()">
                                <i class="icon-user" aria-hidden="true"></i>
                                {{ texts.select_instructor_hint }}
                            </button>

                            <span v-else class="tt-instructor-bar__hint">
                                <i class="icon-user" aria-hidden="true"></i>
                                {{ texts.select_instructor_hint }}
                            </span>
                        </div>
                    </template>
                </timetable>
            </div>
        </div>

        <div v-if="showView === 'trash'">
            <timetable-trash :initialSelectedCalendar="selectedCalendar" :calendars="calendars" :trash-url="trashUrl"
                :restore-url="restoreUrl" :delete-forever-url="deleteForeverUrl" :trash-filters="trashFilters"
                :events-info-url="eventsInfoUrl" @toggle-menu="toggleMenu"
                @hide-trash-view="hideTrashView"></timetable-trash>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
// import { setupCalendar } from "v-calendar";

import { loading } from "./mixins/LoadingMixin";
import { EventBus } from "./mixins/EventBus";
import { Menu } from "./mixins/Menu";
import TimetableListFilter from "./TimetableListFilter.vue";
import ReserveMenu from "./ReserveMenu.vue";
Vue.component("reserve-menu", ReserveMenu);

Vue.component(
    "timetable-list-filter",
    TimetableListFilter
);

export default {
    mixins: [loading, EventBus, Menu],

    props: {
        action: {
            default: "schedule",
        },
        mode: {
            // 'bookings' (lessons + holidays) | 'work_schedule' (recurring templates)
            default: "bookings",
        },
        slotSnapMinutes: {
            // Step (minutes) a click or a sweep on the empty grid is snapped to.
            default: 30,
        },
        calendarListUrls: {
            default: () => [],
        },
        freeEventsUrl: {
            default: null,
        },
        rescheduleEventsUrl: {
            default: null,
        },
        dragMode: {
            default: "manager",
        },
        defaultDurationInMinutes: {
            default: 120,
        },

        restrictPracticeToFreeSlots: {
            default: false,
        },
        selectedCalendarId: {
            default: null,
        },
        showCalendars: {
            default: () => [],
        },
        showFilters: {
            default: () => [],
        },
        showScheduleView: {
            default: false,
        },
        showMonthView: {
            default: false,
        },
        userIsScheduling: {
            default: false,
        },
        showTrashView: {
            default: true,
        },
        hidePastEvents: {
            default: false,
        },
        hideVacationEvents: {
            default: false,
        },
        trashUrl: {
            default: null,
        },
        restoreUrl: {
            default: null,
        },
        deleteEventsUrl: {
            default: null,
        },
        deleteForeverUrl: {
            default: null,
        },
        eventsInfoUrl: {
            default: "",
        },
        trashFilters: {
            default: () => { },
        },
        highlighted: {
            default: null,
        },
        highlightedCalendars: {
            default: () => [],
        },
        eventExtraFields: {
            default: () => [],
        },
        translations: {
            default: () => { },
        },
        showHowToRegister: {
            default: false,
        },
        scheduleEventParams: {
            default: () => { },
        },
        formats: {
            title: "MMMM YYYY",
            weekdays: "WW",
            navMonths: "MMM",
            input: ["L", "YYYY-MM-DD", "YYYY/MM/DD"], // Only for `v-date-picker`
            dayPopover: "L", // Only for `v-date-picker`
            data: ["L", "YYYY-MM-DD", "YYYY/MM/DD"], // For attribute dates
        },
    },

    data() {
        return {
            date: new Date(),
            calendarListUrl:
                typeof this.calendarListUrls == "string"
                    ? this.calendarListUrls
                    : this.calendarListUrls[0].url,
            selectedCalendar: {},
            calendars: this.showCalendars,
            filters: this.showFilters,
            selectedGearboxType: null,
            selectedCarModel: null,
            showView: "timetable", // 'trash' | 'timetable'
            texts: {
                // Defaults first: this used to be a bare spread, so any key missing from
                // a locale rendered as an empty string instead of falling back.
                select_instructor_hint: 'Selectează un instructor',
                clear_instructor: 'Renunță la instructor',
                vacation_add: 'Adaugă concediu',
                vacation_select_days: 'Selectează zile',
                vacation_confirm: 'Creează concediu',
                cancel: 'Renunță',
                ...this.translations,
            },
            locale: window.userLocale,
            calendarSearch: "",
            view: 'week',
            oldView: 'week',
            highlightedCalendarsMap: {
                ...this.highlightedCalendars.reduce((acc, calendarId) => {
                    acc[calendarId] = true;
                    return acc;
                }, {}),
            },
        };
    },

    //   created() {
    //     setupCalendar({
    //       locale: window.userLocale || "ro",
    //       firstDayOfWeek: 2,
    //     });
    //   },

    mounted() {
        console.log("Timetable List Component Mounted.");

        this.getCalendarsByUrl();

        this.eventBus.$on("date-changed", this.dateChanged);
        this.eventBus.$on("show-trash-view", () => (this.showView = "trash"));
        this.eventBus.$on("view-changed", (view) => (this.view = view));
        this.eventBus.$on("created-event", (event) => {
            console.log("Event created:", event);
            this.highlightedCalendarsMap = {
                ...this.highlightedCalendarsMap,
                [event.model_id]: true,
            };
        });
    },

    methods: {
        addVacation(type = "vacation") {
            this.eventBus.$emit("open-vacation-modal", { type });
        },

        startVacationSelect() {
            this.eventBus.$emit("toggle-vacation-select");
        },

        cancelVacationSelect() {
            this.eventBus.$emit("toggle-vacation-select");
        },

        confirmVacationSelect() {
            this.eventBus.$emit("confirm-vacation-selection");
        },

        selectCalendar(calendar) {
            if (this.isLoading) return;
            this.selectedCalendar = calendar;

            this.eventBus.$emit("selected-calendar", calendar);
        },

        setGearboxType(gearboxType) {
            if (this.isLoading) return;

            this.selectedGearboxType =
                this.selectedGearboxType === gearboxType ? null : gearboxType;
            this.selectedCarModel = null;

            this.selectCalendar(null);
        },

        setCarModel(carModel) {
            if (this.isLoading) return;

            this.selectedCarModel = this.selectedCarModel === carModel ? null : carModel;

            this.selectCalendar(null);
        },

        dayClicked(day) {
            this.eventBus.$emit("day-clicked", day.date);

            this.$refs.datepicker.move(day.date);
        },

        getCalendarsByUrl() {
            if (!this.calendarListUrl) return;

            this.loading(true);

            axios
                .get(this.calendarListUrl)
                .then((response) => {
                    this.calendars = response.data.calendars;
                    this.filters = response.data.filters;

                    if (response.data.selected_filters?.gearbox_type) {
                        this.selectedGearboxType = this.filters.find(
                            (filter) => filter.key === "gearbox_type"
                        )?.options.find(
                            (option) => option.value === response.data.selected_filters.gearbox_type
                        ) || null;
                    }

                    // this.selectedCarModel =
                    //   this.selectedGearboxType.sub_filters[0].options[0];
                })
                .catch((error) => {
                    this.$notify({
                        group: "app",
                        text: error?.response?.data?.message || 'A apărut o eroare. Încercați din nou.',
                        type: "error",
                    });
                })
                // selectCalendar/setGearboxType/setCarModel all early-return while
                // isLoading, so releasing it here is what keeps a failed request from
                // silently swallowing every later click in this panel.
                .finally(() => {
                    this.loading(false);
                });
        },

        dateChanged(date) {
            this.date = moment(date).toDate();

            this.$refs.datepicker.move(date);
        },

        toggleFreePlacesView() {
            if (this.view === "free_places") {
                this.eventBus.$emit("view-changed", this.oldView);
            } else {
                this.oldView = this.view;
                this.eventBus.$emit("view-changed", "free_places");
            }
        },

        hideTrashView() {
            this.showView = "timetable";
            this.eventBus.$emit("update-events");
        },

        getFilteredCalendars() {
            return _.filter(this.calendars, (calendar) => {
                if (
                    this.calendarSearch &&
                    -1 ===
                    calendar.title
                        .toLowerCase()
                        .search(this.calendarSearch.toLowerCase())
                ) {
                    return false;
                }

                if (
                    this.selectedGearboxType &&
                    calendar.filters.gearbox_type !== this.selectedGearboxType.value
                ) {
                    return false;
                }

                if (
                    this.selectedCarModel &&
                    calendar.filters.car_model !== this.selectedCarModel.value
                ) {
                    return false;
                }

                return true;
            }).map((calendar) => {
                return {
                    ...calendar,
                    isHighlighted: this.highlightedCalendarsMap[calendar.id],
                };
            }).sort((a, b) => {
                return a.title.localeCompare(b.title);
            });
        },
    },

    computed: {
        hasSelectedCalendar() {
            return !!(this.selectedCalendar && this.selectedCalendar.title);
        },

        showTimetableView() {
            return this.showView === "timetable";
        },

        // The "Orarul de lucru" tab drives the same calendar off the recurring
        // work-schedule template endpoints instead of the events endpoints.
        isWorkSchedule() {
            return this.mode === "work_schedule";
        },
        innerAction() {
            // Work-schedule editing is always plain edit (never student-scheduling).
            return this.isWorkSchedule && this.action !== "show" ? "edit" : this.action;
        },
        innerEventsUrl() {
            if (!this.selectedCalendar) return null;
            return this.isWorkSchedule
                ? this.selectedCalendar.event_templates_url
                : this.selectedCalendar.events_url;
        },
        innerStoreUrl() {
            if (!this.selectedCalendar) return null;
            return this.isWorkSchedule
                ? this.selectedCalendar.store_event_templates_url
                : this.selectedCalendar.store_events_url;
        },
        innerUpdateUrl() {
            if (!this.selectedCalendar) return null;
            return this.isWorkSchedule
                ? this.selectedCalendar.update_event_templates_url
                : this.selectedCalendar.update_events_url;
        },
        innerDeleteUrl() {
            if (this.isWorkSchedule) {
                return this.selectedCalendar && this.selectedCalendar.delete_event_templates_url;
            }
            return this.deleteEventsUrl;
        },
        innerFreeEventsUrl() {
            // Free-slot booking and holidays only apply to the bookings calendar.
            return this.isWorkSchedule ? null : this.freeEventsUrl;
        },
        innerEventExtraFields() {
            // Attendance / payment / review flags describe a booked lesson; a
            // work-schedule template is just a recurring time slot.
            return this.isWorkSchedule ? [] : this.eventExtraFields;
        },
        innerEventsInfoUrl() {
            // The work-schedule grid is fed EventTemplate rows, whose ids live in a
            // different table. Sending them to the events info endpoint resolved to
            // whatever Event happened to share the id, so the popup showed a random
            // student's lesson. Templates have no info endpoint; skip the fetch.
            return this.isWorkSchedule ? null : this.eventsInfoUrl;
        },
        // Holidays belong to the instructor, so they have nothing to do with whether a
        // student happens to be picked. Requiring action === 'edit' tied them to that:
        // the action turns into 'schedule' the moment a student is selected, and the
        // controls vanished mid-task.
        //
        // What actually keeps these away from students is the payload -- only the
        // backend's calendar list carries the endpoints -- backed by `edit planning`
        // on the routes themselves. So this only has to hide them where they make no
        // sense: read-only, and the work-schedule tab.
        innerVacationStoreUrl() {
            if (this.isWorkSchedule || this.action === "show" || !this.selectedCalendar) return null;
            return this.selectedCalendar.vacation_store_url || null;
        },
        innerVacationDeleteUrl() {
            if (this.isWorkSchedule || this.action === "show" || !this.selectedCalendar) return null;
            return this.selectedCalendar.vacation_delete_url || null;
        },
        filteredHighlightedCalendars() {
            return this.getFilteredCalendars().filter((c) => c.isHighlighted);
        },
        filteredCalendars() {
            return this.getFilteredCalendars().filter((c) => !c.isHighlighted);
        },
    },

    watch: {
        calendarListUrl() {
            this.calendars = [];
            this.filters = [];
            this.getCalendarsByUrl();
        },

        highlightedCalendars() {
            this.highlightedCalendarsMap = {
                ...this.highlightedCalendars.reduce((acc, calendarId) => {
                    acc[calendarId] = true;
                    return acc;
                }, {}),
            };
        },
    },
};
</script>
<style lang="scss"></style>
